module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel1-en-GB@2x-0f8c2de2c1ecd4eb0f63c3ab7063cc3e.png";